import MyBHAlertBlock from "@components/Blocks/FirebaseNotificationPrompt/MyBHAlertBlock";
import FollowTrendingTopics from "@components/Blocks/FollowTrendingTopics/FollowTrendingTopics";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";

import { MyBHLayoutOneProps } from "../MyBHLayoutOne";
import { ColumnItem } from "./layout";
import { renderSlot } from "./renderSlot";

export function renderColumn(
  column: ColumnItem[],
  articles: ProcessedArticleData[],
  props: MyBHLayoutOneProps,
  uniqueKeyPrefix = "lg",
) {
  return (
    <div className="flex flex-col gap-5" data-testid="layout-column">
      {column.map((item, i) => {
        if (item.type === "article") {
          return renderSlot(
            {
              index: item.index,
              imgWidth: 381,
              imgHeight: 261.6,
            },
            articles,
            uniqueKeyPrefix,
          );
        }

        if (item.type === "topics") {
          return (
            <FollowTrendingTopics
              key={`${uniqueKeyPrefix}-topics-${i}`}
              {...props}
            />
          );
        }

        if (item.type === "alert") {
          return (
            <MyBHAlertBlock
              key={`${uniqueKeyPrefix}-alert-${i}`}
              {...props}
              uniqueKey={`${uniqueKeyPrefix}-alert-${i}`}
              onToggle={() => {}}
            />
          );
        }

        return null;
      })}
    </div>
  );
}
